import axios from '@/axios'

// Questions

export async function getQuestionBoards () {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/question-boards')
  return response.data.data
}

export async function newQuestionBoard (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v1/intranet/question-boards', data)
  return response.data.data
}

export async function getQuestionBoard (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v1/intranet/question-boards/' + id)
  return response.data.data
}

export async function updateQuestionBoard (id, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v1/intranet/question-boards/' + id, data)
  return response.data.data
}

export async function deleteQuestionBoard (id) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v1/intranet/question-boards/' + id)
  return response.data.data
}

// questions
export async function newQuestion (data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/questions', data)
  return response.data.data
}

export async function addUnitToQuestion (questionId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId + '/units', data)
  return response.data.data
}
export async function removeUnitFromQuestion (questionId, unitId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId + '/units/' + unitId)
  return response.data.data
}

export async function addTagToQuestion (questionId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId + '/tags', data)
  return response.data.data
}
export async function removeTagFromQuestion (questionId, tagId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId + '/tags/' + tagId)
  return response.data.data
}

export async function addQuestionBoardToQuestion (questionId, data) {
  const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId + '/question-board', data)
  return response.data.data
}
export async function removeQuestionBoardFromQuestion (questionId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId + '/question-board')
  return response.data.data
}

export async function getQuestion (questionId) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId)
  return response.data.data
}

export async function listQuestions (page, parameters) {
  const url = import.meta.env.VITE_API_URL + '/v2/intranet/questions?page=' + page + '&with=intranetUser' + parameters

  // if (query) {
  //   url += '?' + query
  // }

  const response = await axios.get(url)
  return response.data
}

export async function updateQuestion (questionId, data) {
  const response = await axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId, data)
  return response.data.data
}

export async function deleteQuestion (questionId) {
  const response = await axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/questions/' + questionId)
  return response.data.data
}

export async function uploadQuestionImage (questionId, formData, sizeTemplate) {
  const res = await axios.post(`${import.meta.env.VITE_API_URL}/v2/intranet/questions/${questionId}/question-images?size_template=${sizeTemplate}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return res.data.data
}

export async function createQuestionFrom (id) {
  const response = await axios.post(import.meta.env.VITE_API_URL + `/v2/intranet/questions/${id}/create-from`)
  return response.data.data
}

export default {
  getQuestionBoards,
  newQuestionBoard,
  getQuestionBoard,
  updateQuestionBoard,
  deleteQuestionBoard,
  newQuestion,
  getQuestion,
  listQuestions,
  updateQuestion,
  deleteQuestion,
  uploadQuestionImage,
  createQuestionFrom,
  addUnitToQuestion,
  removeUnitFromQuestion,
  addTagToQuestion,
  removeTagFromQuestion,
  addQuestionBoardToQuestion,
  removeQuestionBoardFromQuestion
}
